import React from "react";
import withStyles from "@mui/styles/withStyles";
import { Box } from "@mui/material";
import Table from "../../components/Table/Table";
import MyAchievementsItemTitle from "./MyAchievementsItemTitle";
import MyAchievementsButtons from "./MyAchievementsButtons";
import { visionURL } from "../../config/environment";
import ScoreCell from "../../components/ScoreCell";
import AchievementTypeIcon from "../../components/Icons/AchievementTypeIcon";
import { formatDate } from "../../utils/datetime";
import { iltClassTypes } from "../../constants";

const columns = [
  {
    title: "Type",
    field: "courseType",
    options: {
      sorting: false
    },
    cellStyle: {
      textAlign: "center",
      borderBottom: "none",
      width: 72
    },
    render: rowData => <AchievementTypeIcon type={rowData.courseType} />
  },
  {
    title: "Title",
    field: "courseTitle",
    filterPlaceholder: "titleAll",
    options: {
      sorting: true,
      filtering: true
    },
    cellStyle: {
      minWidth: 200
    },
    render: rowData => (
      <MyAchievementsItemTitle
        key={rowData.id}
        id={rowData.id}
        link={rowData.link}
        courseTitle={rowData.courseTitle}
      />
    )
  },
  {
    title: "score",
    field: "postScore",
    filterPlaceholder: "scoreAll",
    options: {
      filtering: true,
      sorting: true
    },
    customSort: (a, b) => a > b,
    cellStyle: {
      width: 160,
      minWidth: 160
    },
    render: rowData => (
      <ScoreCell
        scoreInfo={rowData.scoreInfo}
        isSelfAssigned={rowData.isSelfAssigned}
        isIlt={iltClassTypes.includes(rowData.courseType)}
        isActive={rowData.isActive}
        passingScore={rowData.passingScore}
        passedCompletionDate={rowData.passedCompletionDate}
      />
    )
  },
  {
    title: "Date Completed",
    field: "completedAt",
    options: {
      sorting: true
    },
    type: "date",
    customSort: (a, b) => new Date(b) - new Date(a),
    cellStyle: {
      width: 184
    },
    render: rowData =>
      (iltClassTypes.includes(rowData.courseType) && rowData.isActive) ||
      !rowData.completedAt
        ? ""
        : formatDate(rowData.completedAt)
  },
  {
    title: "Actions",
    field: "actions",
    options: {
      sorting: false
    },
    cellStyle: {
      textAlign: "center",
      width: 80
    },
    render: rowData => {
      return (
        <Box display="flex" height="0px" alignItems="center">
          {!!rowData.hasCertificate && rowData.isPassed && (
            <MyAchievementsButtons
              isIlt={iltClassTypes.includes(rowData.courseType)}
              isActive={rowData.isActive}
              isAttended={rowData.isAttended}
              isPassed={rowData.isPassed}
              printUrl={`${visionURL}/certificates/print/${rowData.id}`}
              emailModalType="certificate"
              dlgKey={rowData.id}
              trainingRecordId={rowData.id}
            />
          )}
        </Box>
      );
    }
  }
];

const styles = theme => ({
  root: {
    marginTop: theme.spacing(4),
    backgroundColor: theme.palette.secondary.background,
    paddingBottom: theme.spacing(4)
  }
});

// const emailCertificateUrl = `${visionURL}/certificates/email`;
// const emailReportUrl = `${visionURL}/reports/8838/run_report`;
// const printCertificateUrl = `${visionURL}/certificates/print`;
// const printReportUrl = `${visionURL}/reports/8838/run_report`;

class MyAchievements extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div data-qa="performance-achievements" className={classes.root}>
        <Table
          columns={columns}
          remoteSource={`${visionURL}/learning_center/api/completions?my_achievement[scope]=all`}
        />
      </div>
    );
  }
}
export default withStyles(styles, { withTheme: true })(MyAchievements);
